import { useState } from "react";
import PropTypes from "prop-types";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import NativeObject from "../../components/NativeObject/NativeObject";
import { Grid } from "@mui/material";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function PilaresDesktop({ app, config }) {
  const [accordion, setAccordion] = useState({
    execucao: false,
    organi: false,
    opera: false,
  });

  return (
    <div className="app pilares">
      <div className="appContent">
        <Card
          app={app}
          header={{
            hardTitle: "Pilares: ",
          }}

          className={"container-pilares"}
        >
          <div className="container-buttons">
            {/* Pilar Execução */}
            <button
              className="button-accodion"
              onClick={() =>
                setAccordion({ ...accordion, execucao: !accordion.execucao })
              }
            >
              <span> Execução </span>
              {accordion.execucao ? (
                <KeyboardArrowUpIcon sx={{ color: "#ff007f" }} />
              ) : (
                <KeyboardArrowDownIcon sx={{ color: "#ff007f" }} />
              )}
            </button>
            {accordion.execucao ? (
              <div className="container-table-pilares">
                <LayoutCardWrapper>
                  <LayoutCardsWrapper>
                    <Grid container rowGap={2}>
                      <LayoutCardWrapper style={{ height: "553px" }}>
                        {/* Pilar Execução */}
                        <Card
                          app={app}
                          exportTable
                          exportTableId="sLPJN"
                          style={{ width: "100%" }}
                          className={"container-table"}
                        >
                          <NativeObject
                            app={app}
                            key="sLPJN"
                            reference={{ id: "sLPJN" }}
                          />
                        </Card>
                      </LayoutCardWrapper>
                    </Grid>
                  </LayoutCardsWrapper>
                </LayoutCardWrapper>
              </div>
            ) : null}

            {/* Pilar Organizacional */}
            <button
              className="button-accodion"
              onClick={() =>
                setAccordion({ ...accordion, organi: !accordion.organi })
              }
            >
              <span> Organizacional </span>
              {accordion.organi ? (
                <KeyboardArrowUpIcon sx={{ color: "#ff007f" }} />
              ) : (
                <KeyboardArrowDownIcon sx={{ color: "#ff007f" }} />
              )}
            </button>
            {accordion.organi ? (
              <div className="container-table-pilares">
                <LayoutCardWrapper>
                  <LayoutCardsWrapper>
                    <Grid container rowGap={2}>
                      <LayoutCardWrapper
                        style={{ height: "553px", width: "100%" }}
                      >
                        {/* Pilar Organizacional */}
                        <Card
                          app={app}
                          exportTable
                          exportTableId="TBcNRN"
                          style={{ width: "100%" }}
                          className={"container-table"}
                        >
                          <NativeObject
                            app={app}
                            key="TBcNRN"
                            reference={{ id: "TBcNRN" }}
                          />
                        </Card>
                      </LayoutCardWrapper>
                    </Grid>
                  </LayoutCardsWrapper>
                </LayoutCardWrapper>
              </div>
            ) : null}

            {/* Pilar Operacional */}
            <button
              className="button-accodion"
              onClick={() =>
                setAccordion({ ...accordion, opera: !accordion.opera })
              }
            >
              <span> Operacional </span>
              {accordion.opera ? (
                <KeyboardArrowUpIcon sx={{ color: "#ff007f" }} />
              ) : (
                <KeyboardArrowDownIcon sx={{ color: "#ff007f" }} />
              )}
            </button>
            {accordion.opera ? (
              <div className="container-table-pilares">
                <LayoutCardWrapper>
                  <LayoutCardsWrapper>
                    <Grid container rowGap={2}>
                      <LayoutCardWrapper
                        style={{ height: "553px", width: "100%" }}
                      >
                        {/* Pilar Operazacional */}
                        <Card
                          app={app}
                          exportTable
                          exportTableId="MyDzPU"
                          style={{ width: "100%" }}
                          className={"container-table"}
                        >
                          <NativeObject
                            app={app}
                            key="MyDzPU"
                            reference={{ id: "MyDzPU" }}
                          />
                        </Card>
                      </LayoutCardWrapper>
                    </Grid>
                  </LayoutCardsWrapper>
                </LayoutCardWrapper>
              </div>
            ) : null}
          </div>
        </Card>
      </div>
    </div>
  );
}

PilaresDesktop.defaultProps = {
  app: null,
  config: {},
};

PilaresDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PilaresDesktop;
